import { Component } from '@angular/core';

@Component({
	moduleId: module.id,
	selector: 'svg-do-more-with-less',
	template: `
		<svg width="60" height="60" version="1.1" viewBox="0 0 15.875 15.875" xmlns="http://www.w3.org/2000/svg">
			<g>
				<g fill="none" stroke="#0C3121" stroke-linecap="round" stroke-linejoin="round" stroke-width=".52917">
					<path d="m1.2992 7.7657c1.2157-2.7081 3.8672-7.3303 3.8672-7.3303s2.6516
					4.6222 3.8672 7.3303c2.1948 4.8892-0.78661 7.7951-3.8672 7.7897-3.0806
					0.0054-6.0621-2.9005-3.8672-7.7897zm6.9454 2.9992c-0.32486 1.3277-0.47433 2.9039-3.201 3.0773"/>
					<path d="m10.797 5.6651c0.68069-1.5413 2.1653-4.172 2.1653-4.172s1.4847
					2.6307 2.1653 4.172c1.2289 2.7826-0.44044 4.4365-2.1653 4.4334-1.7249
					0.0031-3.3943-1.6508-2.1653-4.4334zm3.8889 1.7069c-0.1819 0.75565-0.26558 1.6527-1.7923 1.7514"/>
				</g>
			</g>
		</svg>

	`,
})

export class SVGDoMoreWithLessComponent {

}
